import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faCube } from '@fortawesome/free-solid-svg-icons';

/**
 * Generic placeholder icon used when a product has no image.
 * Keep this in one place so different pages stay consistent.
 *
 * Candidates (FontAwesome free-solid):
 * - faCube: neutral “item/object” (current)
 * - faShapes: generic category/item
 * - faCartShopping: shopping context
 * - faBasketShopping: shopping basket context
 * - faTag: label/price-tag vibe
 * - faImage: explicit “no image” placeholder
 * - faCircleQuestion: explicit “unknown” placeholder
 * - faBarcode: product-code vibe
 */
export const PRODUCT_PLACEHOLDER_ICON: IconDefinition = faCube;
